import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createVNode as _createVNode, mergeProps as _mergeProps, withModifiers as _withModifiers, Teleport as _Teleport } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-center py-5"
}
const _hoisted_2 = {
  class: "spinner-border text-primary",
  role: "status"
}
const _hoisted_3 = { class: "visually-hidden" }
const _hoisted_4 = {
  key: 1,
  class: "alert alert-danger"
}
const _hoisted_5 = {
  key: 2,
  class: "asset-details-wrapper"
}
const _hoisted_6 = { class: "asset-hero" }
const _hoisted_7 = { class: "hero-content" }
const _hoisted_8 = { class: "hero-left" }
const _hoisted_9 = { class: "hero-info" }
const _hoisted_10 = { class: "asset-title" }
const _hoisted_11 = { class: "asset-meta" }
const _hoisted_12 = { class: "meta-item" }
const _hoisted_13 = {
  key: 0,
  class: "meta-item"
}
const _hoisted_14 = { class: "hero-right" }
const _hoisted_15 = { class: "status-text" }
const _hoisted_16 = { class: "modern-tabs" }
const _hoisted_17 = { class: "tab-content-wrapper" }
const _hoisted_18 = {
  key: 0,
  class: "asset-details-content"
}
const _hoisted_19 = { class: "asset-overview-grid" }
const _hoisted_20 = { class: "asset-overview-chart" }
const _hoisted_21 = { class: "chart-empty-state" }
const _hoisted_22 = {
  class: "spinner-border text-primary",
  role: "status"
}
const _hoisted_23 = { class: "visually-hidden" }
const _hoisted_24 = { class: "chart-header" }
const _hoisted_25 = { class: "chart-title" }
const _hoisted_26 = { class: "chart-actions" }
const _hoisted_27 = ["onClick", "title"]
const _hoisted_28 = ["onClick", "title"]
const _hoisted_29 = ["onClick", "title"]
const _hoisted_30 = ["onClick", "title"]
const _hoisted_31 = { class: "chart-body" }
const _hoisted_32 = { class: "chart-empty-state" }
const _hoisted_33 = { class: "chart-empty-text" }
const _hoisted_34 = { class: "chart-empty-state" }
const _hoisted_35 = {
  class: "spinner-border text-primary",
  role: "status"
}
const _hoisted_36 = { class: "visually-hidden" }
const _hoisted_37 = { class: "chart-header" }
const _hoisted_38 = { class: "chart-title" }
const _hoisted_39 = { class: "chart-actions" }
const _hoisted_40 = ["onClick", "title"]
const _hoisted_41 = ["onClick", "title"]
const _hoisted_42 = ["onClick", "title"]
const _hoisted_43 = ["onClick", "title"]
const _hoisted_44 = { class: "chart-body" }
const _hoisted_45 = { class: "chart-empty-state" }
const _hoisted_46 = { class: "chart-empty-text" }
const _hoisted_47 = { class: "chart-empty-state" }
const _hoisted_48 = {
  class: "spinner-border text-primary",
  role: "status"
}
const _hoisted_49 = { class: "visually-hidden" }
const _hoisted_50 = { class: "chart-header" }
const _hoisted_51 = { class: "chart-title" }
const _hoisted_52 = { class: "chart-actions" }
const _hoisted_53 = ["onClick", "title"]
const _hoisted_54 = ["onClick", "title"]
const _hoisted_55 = ["onClick", "title"]
const _hoisted_56 = ["onClick", "title"]
const _hoisted_57 = { class: "chart-body" }
const _hoisted_58 = { class: "chart-empty-state" }
const _hoisted_59 = { class: "chart-empty-text" }
const _hoisted_60 = { class: "chart-empty-state" }
const _hoisted_61 = {
  class: "spinner-border text-primary",
  role: "status"
}
const _hoisted_62 = { class: "visually-hidden" }
const _hoisted_63 = { class: "chart-header" }
const _hoisted_64 = { class: "chart-title" }
const _hoisted_65 = { class: "chart-actions" }
const _hoisted_66 = ["onClick", "title"]
const _hoisted_67 = ["onClick", "title"]
const _hoisted_68 = ["onClick", "title"]
const _hoisted_69 = ["onClick", "title"]
const _hoisted_70 = { class: "chart-body" }
const _hoisted_71 = { class: "chart-empty-state" }
const _hoisted_72 = { class: "chart-empty-text" }
const _hoisted_73 = { class: "chart-header" }
const _hoisted_74 = { class: "chart-title" }
const _hoisted_75 = { class: "chart-actions" }
const _hoisted_76 = ["disabled", "title"]
const _hoisted_77 = ["disabled", "title"]
const _hoisted_78 = ["disabled", "title"]
const _hoisted_79 = ["disabled", "title"]
const _hoisted_80 = ["disabled", "title"]
const _hoisted_81 = { class: "chart-body" }
const _hoisted_82 = {
  key: 0,
  class: "chart-empty-state"
}
const _hoisted_83 = {
  class: "spinner-border text-primary",
  role: "status"
}
const _hoisted_84 = { class: "visually-hidden" }
const _hoisted_85 = {
  key: 1,
  class: "chart-empty-state"
}
const _hoisted_86 = { class: "chart-empty-text" }
const _hoisted_87 = { class: "asset-overview-side" }
const _hoisted_88 = { class: "asset-tile asset-tile-image" }
const _hoisted_89 = { class: "asset-tile-header" }
const _hoisted_90 = { class: "asset-tile-title" }
const _hoisted_91 = ["title"]
const _hoisted_92 = ["src", "alt"]
const _hoisted_93 = { class: "asset-tile-media-overlay" }
const _hoisted_94 = { class: "asset-tile asset-tile-stats" }
const _hoisted_95 = { class: "asset-tile-header" }
const _hoisted_96 = { class: "asset-tile-title" }
const _hoisted_97 = {
  key: 0,
  class: "asset-stats-grid"
}
const _hoisted_98 = { class: "asset-stat" }
const _hoisted_99 = { class: "asset-stat-header" }
const _hoisted_100 = { class: "asset-stat-value" }
const _hoisted_101 = { class: "asset-stat" }
const _hoisted_102 = { class: "asset-stat-header" }
const _hoisted_103 = { class: "asset-stat-value" }
const _hoisted_104 = { class: "asset-stat" }
const _hoisted_105 = { class: "asset-stat-header" }
const _hoisted_106 = { class: "asset-stat-value" }
const _hoisted_107 = { class: "asset-stat" }
const _hoisted_108 = { class: "asset-stat-header" }
const _hoisted_109 = { class: "asset-stat-value" }
const _hoisted_110 = { class: "asset-stat" }
const _hoisted_111 = { class: "asset-stat-header" }
const _hoisted_112 = { class: "asset-stat-value" }
const _hoisted_113 = {
  key: 6,
  class: "asset-stats-grid"
}
const _hoisted_114 = { class: "asset-stat-header" }
const _hoisted_115 = { class: "asset-stat-value" }
const _hoisted_116 = { class: "asset-stat-header" }
const _hoisted_117 = { class: "asset-stat-value" }
const _hoisted_118 = { class: "asset-stat" }
const _hoisted_119 = { class: "asset-stat-header" }
const _hoisted_120 = { class: "asset-stat-value" }
const _hoisted_121 = { class: "asset-stat-header" }
const _hoisted_122 = { class: "asset-stat-value" }
const _hoisted_123 = { class: "asset-tile asset-tile-info" }
const _hoisted_124 = { class: "asset-tile-header" }
const _hoisted_125 = { class: "asset-tile-title" }
const _hoisted_126 = { class: "asset-info-list" }
const _hoisted_127 = { class: "asset-info-item" }
const _hoisted_128 = { class: "asset-info-label" }
const _hoisted_129 = { class: "asset-info-value" }
const _hoisted_130 = {
  key: 0,
  class: "asset-info-item"
}
const _hoisted_131 = { class: "asset-info-label" }
const _hoisted_132 = { class: "asset-info-value" }
const _hoisted_133 = { class: "asset-info-item" }
const _hoisted_134 = { class: "asset-info-label" }
const _hoisted_135 = { class: "asset-info-value" }
const _hoisted_136 = {
  key: 1,
  class: "asset-info-item"
}
const _hoisted_137 = { class: "asset-info-label" }
const _hoisted_138 = { class: "asset-info-value" }
const _hoisted_139 = { key: 1 }
const _hoisted_140 = { key: 2 }
const _hoisted_141 = { class: "chart-header" }
const _hoisted_142 = { class: "chart-title" }
const _hoisted_143 = { class: "chart-actions" }
const _hoisted_144 = ["title"]
const _hoisted_145 = ["disabled", "title"]
const _hoisted_146 = ["disabled", "title"]
const _hoisted_147 = ["disabled", "title"]
const _hoisted_148 = ["disabled", "title"]
const _hoisted_149 = {
  key: 0,
  class: "chart-body"
}
const _hoisted_150 = {
  key: 1,
  class: "chart-body chart-fullscreen-empty"
}
const _hoisted_151 = {
  key: 0,
  class: "chart-empty-state"
}
const _hoisted_152 = {
  class: "spinner-border text-primary",
  role: "status"
}
const _hoisted_153 = { class: "visually-hidden" }
const _hoisted_154 = {
  key: 1,
  class: "chart-empty-state"
}
const _hoisted_155 = { class: "chart-empty-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WagoEnergyStats = _resolveComponent("WagoEnergyStats")!
  const _component_WagoEnergyHeatmap = _resolveComponent("WagoEnergyHeatmap")!
  const _component_LineChart = _resolveComponent("LineChart")!
  const _component_DknUartLatestParamsPanel = _resolveComponent("DknUartLatestParamsPanel")!
  const _component_DknMpsLatestParamsPanel = _resolveComponent("DknMpsLatestParamsPanel")!
  const _component_DknLmsLatestParamsPanel = _resolveComponent("DknLmsLatestParamsPanel")!
  const _component_WagoLatestParamsPanel = _resolveComponent("WagoLatestParamsPanel")!
  const _component_ModbusLatestParamsPanel = _resolveComponent("ModbusLatestParamsPanel")!
  const _component_AssetHistory = _resolveComponent("AssetHistory")!
  const _component_DknAlarmTable = _resolveComponent("DknAlarmTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _mergeProps({ class: "asset-details-container" }, _ctx.$attrs), [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('components.assetDetails.loading')), 1)
            ])
          ]))
        : (_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _cache[17] || (_cache[17] = _createElementVNode("i", { class: "bi bi-exclamation-triangle" }, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.error), 1)
            ]))
          : (_ctx.asset)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _cache[20] || (_cache[20] = _createElementVNode("div", { class: "asset-icon-wrapper" }, [
                        _createElementVNode("i", { class: "bi bi-hdd-rack-fill" })
                      ], -1)),
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("h1", _hoisted_10, _toDisplayString(_ctx.asset.name || _ctx.$t('components.assetDetails.unknownAsset')), 1),
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("span", _hoisted_12, [
                            _cache[18] || (_cache[18] = _createElementVNode("i", { class: "bi bi-upc-scan" }, null, -1)),
                            _createTextVNode(" " + _toDisplayString(_ctx.getSerialNumber()), 1)
                          ]),
                          (_ctx.asset.company)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                                _cache[19] || (_cache[19] = _createElementVNode("i", { class: "bi bi-building" }, null, -1)),
                                _createTextVNode(" " + _toDisplayString(_ctx.asset.company.name), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["status-badge-large", _ctx.getOnlineStatusClass()])
                      }, [
                        _cache[21] || (_cache[21] = _createElementVNode("div", { class: "status-pulse" }, null, -1)),
                        _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.getOnlineStatus()), 1)
                      ], 2),
                      _createElementVNode("button", {
                        class: "btn-back",
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                      }, [
                        _cache[22] || (_cache[22] = _createElementVNode("i", { class: "bi bi-arrow-left" }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('components.assetDetails.backToList')), 1)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("button", {
                    class: _normalizeClass([{active: _ctx.tabContent === _ctx.TAB_DETAILS }, "tab-btn"]),
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setTab(_ctx.TAB_DETAILS)))
                  }, [
                    _cache[23] || (_cache[23] = _createElementVNode("i", { class: "bi bi-info-circle-fill" }, null, -1)),
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.assetDetails.tabs.details')), 1)
                  ], 2),
                  _createElementVNode("button", {
                    class: _normalizeClass([{active: _ctx.tabContent === _ctx.TAB_HISTORY }, "tab-btn"]),
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setTab(_ctx.TAB_HISTORY)))
                  }, [
                    _cache[24] || (_cache[24] = _createElementVNode("i", { class: "bi bi-clock-history" }, null, -1)),
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.assetDetails.tabs.history')), 1)
                  ], 2),
                  (_ctx.isDknLmsAsset)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: _normalizeClass([{active: _ctx.tabContent === _ctx.TAB_ALARMS }, "tab-btn"]),
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setTab(_ctx.TAB_ALARMS)))
                      }, [
                        _cache[25] || (_cache[25] = _createElementVNode("i", { class: "bi bi-bell-fill" }, null, -1)),
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.assetDetails.alarms.tabLabel')), 1)
                      ], 2))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_17, [
                  (_ctx.tabContent === _ctx.TAB_DETAILS)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("div", _hoisted_20, [
                            (_ctx.isWagoModbusAsset)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  (_ctx.chartLoading)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: _normalizeClass(["chart-container chart-container-empty", { 'dark-mode': _ctx.isDarkMode }])
                                      }, [
                                        _createElementVNode("div", _hoisted_21, [
                                          _createElementVNode("div", _hoisted_22, [
                                            _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t('components.assetDetails.loading')), 1)
                                          ])
                                        ])
                                      ], 2))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        (_ctx.energyStats)
                                          ? (_openBlock(), _createBlock(_component_WagoEnergyStats, {
                                              key: 0,
                                              stats: _ctx.energyStats,
                                              "is-dark-mode": _ctx.isDarkMode
                                            }, null, 8, ["stats", "is-dark-mode"]))
                                          : _createCommentVNode("", true),
                                        (_ctx.wagoHasAnyData)
                                          ? (_openBlock(), _createBlock(_component_WagoEnergyHeatmap, {
                                              key: 1,
                                              "chart-series": _ctx.heatmapSeries,
                                              "is-dark-mode": _ctx.isDarkMode,
                                              "range-start-ts": _ctx.heatmapRangeStartTs,
                                              "range-end-ts": _ctx.heatmapRangeEndTs
                                            }, null, 8, ["chart-series", "is-dark-mode", "range-start-ts", "range-end-ts"]))
                                          : _createCommentVNode("", true),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.wagoChartGroups, (group) => {
                                          return (_openBlock(), _createElementBlock(_Fragment, {
                                            key: group.id
                                          }, [
                                            (_ctx.wagoGroupHasData(group))
                                              ? (_openBlock(), _createElementBlock("div", {
                                                  key: 0,
                                                  class: _normalizeClass(["chart-container mb-3", { 'dark-mode': _ctx.isDarkMode }])
                                                }, [
                                                  _createElementVNode("div", _hoisted_24, [
                                                    _createElementVNode("h3", _hoisted_25, [
                                                      _cache[26] || (_cache[26] = _createElementVNode("i", { class: "bi bi-graph-up" }, null, -1)),
                                                      _createElementVNode("span", null, _toDisplayString(_ctx.$t(group.titleKey)), 1)
                                                    ]),
                                                    _createElementVNode("div", _hoisted_26, [
                                                      _createElementVNode("button", {
                                                        class: "btn btn-custom",
                                                        onClick: ($event: any) => (_ctx.resetZoom('wago-chart-' + group.id)),
                                                        title: _ctx.$t('components.assetDetails.actions.resetZoom')
                                                      }, [...(_cache[27] || (_cache[27] = [
                                                        _createElementVNode("i", { class: "bi bi-arrow-clockwise" }, null, -1)
                                                      ]))], 8, _hoisted_27),
                                                      _createElementVNode("button", {
                                                        class: "btn btn-custom",
                                                        onClick: ($event: any) => (_ctx.exportWagoGroupToPng(group)),
                                                        title: _ctx.$t('components.assetDetails.actions.exportPng')
                                                      }, [...(_cache[28] || (_cache[28] = [
                                                        _createElementVNode("i", { class: "bi bi-filetype-png" }, null, -1)
                                                      ]))], 8, _hoisted_28),
                                                      _createElementVNode("button", {
                                                        class: "btn btn-custom",
                                                        onClick: ($event: any) => (_ctx.exportWagoGroupToJpg(group)),
                                                        title: _ctx.$t('components.assetDetails.actions.exportJpg')
                                                      }, [...(_cache[29] || (_cache[29] = [
                                                        _createElementVNode("i", { class: "bi bi-filetype-jpg" }, null, -1)
                                                      ]))], 8, _hoisted_29),
                                                      _createElementVNode("button", {
                                                        class: "btn btn-custom",
                                                        onClick: ($event: any) => (_ctx.exportWagoGroupCsv(group)),
                                                        title: _ctx.$t('components.assetDetails.actions.exportCsv')
                                                      }, [...(_cache[30] || (_cache[30] = [
                                                        _createElementVNode("i", { class: "bi bi-filetype-csv" }, null, -1)
                                                      ]))], 8, _hoisted_30)
                                                    ])
                                                  ]),
                                                  _createElementVNode("div", _hoisted_31, [
                                                    (_openBlock(), _createBlock(_component_LineChart, {
                                                      key: group.id + '-' + (_ctx.isDarkMode ? 'dark' : 'light'),
                                                      height: _ctx.wagoChartHeight,
                                                      "chart-id": 'wago-chart-' + group.id,
                                                      "chart-data": _ctx.wagoChartData(group),
                                                      options: _ctx.wagoChartOptions(group),
                                                      plugins: _ctx.chartPlugins
                                                    }, null, 8, ["height", "chart-id", "chart-data", "options", "plugins"]))
                                                  ])
                                                ], 2))
                                              : _createCommentVNode("", true)
                                          ], 64))
                                        }), 128)),
                                        (!_ctx.wagoHasAnyData)
                                          ? (_openBlock(), _createElementBlock("div", {
                                              key: 2,
                                              class: _normalizeClass(["chart-container chart-container-empty", { 'dark-mode': _ctx.isDarkMode }])
                                            }, [
                                              _createElementVNode("div", _hoisted_32, [
                                                _cache[31] || (_cache[31] = _createElementVNode("i", { class: "bi bi-graph-up" }, null, -1)),
                                                _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.chartError || _ctx.$t('components.assetDetails.noHistory')), 1)
                                              ])
                                            ], 2))
                                          : _createCommentVNode("", true)
                                      ], 64))
                                ], 64))
                              : (_ctx.isDknLmsAsset)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    (_ctx.chartLoading)
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 0,
                                          class: _normalizeClass(["chart-container chart-container-empty", { 'dark-mode': _ctx.isDarkMode }])
                                        }, [
                                          _createElementVNode("div", _hoisted_34, [
                                            _createElementVNode("div", _hoisted_35, [
                                              _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.$t('components.assetDetails.loading')), 1)
                                            ])
                                          ])
                                        ], 2))
                                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dknChartGroups, (group) => {
                                            return (_openBlock(), _createElementBlock(_Fragment, {
                                              key: group.id
                                            }, [
                                              (_ctx.dknGroupHasData(group))
                                                ? (_openBlock(), _createElementBlock("div", {
                                                    key: 0,
                                                    class: _normalizeClass(["chart-container mb-3", { 'dark-mode': _ctx.isDarkMode }])
                                                  }, [
                                                    _createElementVNode("div", _hoisted_37, [
                                                      _createElementVNode("h3", _hoisted_38, [
                                                        _cache[32] || (_cache[32] = _createElementVNode("i", { class: "bi bi-graph-up" }, null, -1)),
                                                        _createElementVNode("span", null, _toDisplayString(_ctx.$t(group.titleKey)), 1)
                                                      ]),
                                                      _createElementVNode("div", _hoisted_39, [
                                                        _createElementVNode("button", {
                                                          class: "btn btn-custom",
                                                          onClick: ($event: any) => (_ctx.resetZoom('dkn-chart-' + group.id)),
                                                          title: _ctx.$t('components.assetDetails.actions.resetZoom')
                                                        }, [...(_cache[33] || (_cache[33] = [
                                                          _createElementVNode("i", { class: "bi bi-arrow-clockwise" }, null, -1)
                                                        ]))], 8, _hoisted_40),
                                                        _createElementVNode("button", {
                                                          class: "btn btn-custom",
                                                          onClick: ($event: any) => (_ctx.exportDknGroupToPng(group)),
                                                          title: _ctx.$t('components.assetDetails.actions.exportPng')
                                                        }, [...(_cache[34] || (_cache[34] = [
                                                          _createElementVNode("i", { class: "bi bi-filetype-png" }, null, -1)
                                                        ]))], 8, _hoisted_41),
                                                        _createElementVNode("button", {
                                                          class: "btn btn-custom",
                                                          onClick: ($event: any) => (_ctx.exportDknGroupToJpg(group)),
                                                          title: _ctx.$t('components.assetDetails.actions.exportJpg')
                                                        }, [...(_cache[35] || (_cache[35] = [
                                                          _createElementVNode("i", { class: "bi bi-filetype-jpg" }, null, -1)
                                                        ]))], 8, _hoisted_42),
                                                        _createElementVNode("button", {
                                                          class: "btn btn-custom",
                                                          onClick: ($event: any) => (_ctx.exportDknGroupCsv(group)),
                                                          title: _ctx.$t('components.assetDetails.actions.exportCsv')
                                                        }, [...(_cache[36] || (_cache[36] = [
                                                          _createElementVNode("i", { class: "bi bi-filetype-csv" }, null, -1)
                                                        ]))], 8, _hoisted_43)
                                                      ])
                                                    ]),
                                                    _createElementVNode("div", _hoisted_44, [
                                                      (_openBlock(), _createBlock(_component_LineChart, {
                                                        key: 'dkn-' + group.id + '-' + (_ctx.isDarkMode ? 'dark' : 'light'),
                                                        height: _ctx.wagoChartHeight,
                                                        "chart-id": 'dkn-chart-' + group.id,
                                                        "chart-data": _ctx.dknChartData(group),
                                                        options: _ctx.dknChartOptions(group),
                                                        plugins: _ctx.chartPlugins
                                                      }, null, 8, ["height", "chart-id", "chart-data", "options", "plugins"]))
                                                    ])
                                                  ], 2))
                                                : _createCommentVNode("", true)
                                            ], 64))
                                          }), 128)),
                                          (!_ctx.dknHasAnyData)
                                            ? (_openBlock(), _createElementBlock("div", {
                                                key: 0,
                                                class: _normalizeClass(["chart-container chart-container-empty", { 'dark-mode': _ctx.isDarkMode }])
                                              }, [
                                                _createElementVNode("div", _hoisted_45, [
                                                  _cache[37] || (_cache[37] = _createElementVNode("i", { class: "bi bi-graph-up" }, null, -1)),
                                                  _createElementVNode("div", _hoisted_46, _toDisplayString(_ctx.chartError || _ctx.$t('components.assetDetails.noHistory')), 1)
                                                ])
                                              ], 2))
                                            : _createCommentVNode("", true)
                                        ], 64))
                                  ], 64))
                                : (_ctx.isDknMpsAsset)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                      (_ctx.chartLoading)
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 0,
                                            class: _normalizeClass(["chart-container chart-container-empty", { 'dark-mode': _ctx.isDarkMode }])
                                          }, [
                                            _createElementVNode("div", _hoisted_47, [
                                              _createElementVNode("div", _hoisted_48, [
                                                _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.$t('components.assetDetails.loading')), 1)
                                              ])
                                            ])
                                          ], 2))
                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mpsChartGroups, (group) => {
                                              return (_openBlock(), _createElementBlock(_Fragment, {
                                                key: group.id
                                              }, [
                                                (_ctx.dknGroupHasData(group))
                                                  ? (_openBlock(), _createElementBlock("div", {
                                                      key: 0,
                                                      class: _normalizeClass(["chart-container mb-3", { 'dark-mode': _ctx.isDarkMode }])
                                                    }, [
                                                      _createElementVNode("div", _hoisted_50, [
                                                        _createElementVNode("h3", _hoisted_51, [
                                                          _cache[38] || (_cache[38] = _createElementVNode("i", { class: "bi bi-graph-up" }, null, -1)),
                                                          _createElementVNode("span", null, _toDisplayString(_ctx.$t(group.titleKey)), 1)
                                                        ]),
                                                        _createElementVNode("div", _hoisted_52, [
                                                          _createElementVNode("button", {
                                                            class: "btn btn-custom",
                                                            onClick: ($event: any) => (_ctx.resetZoom('mps-chart-' + group.id)),
                                                            title: _ctx.$t('components.assetDetails.actions.resetZoom')
                                                          }, [...(_cache[39] || (_cache[39] = [
                                                            _createElementVNode("i", { class: "bi bi-arrow-clockwise" }, null, -1)
                                                          ]))], 8, _hoisted_53),
                                                          _createElementVNode("button", {
                                                            class: "btn btn-custom",
                                                            onClick: ($event: any) => (_ctx.exportMpsGroupToPng(group)),
                                                            title: _ctx.$t('components.assetDetails.actions.exportPng')
                                                          }, [...(_cache[40] || (_cache[40] = [
                                                            _createElementVNode("i", { class: "bi bi-filetype-png" }, null, -1)
                                                          ]))], 8, _hoisted_54),
                                                          _createElementVNode("button", {
                                                            class: "btn btn-custom",
                                                            onClick: ($event: any) => (_ctx.exportMpsGroupToJpg(group)),
                                                            title: _ctx.$t('components.assetDetails.actions.exportJpg')
                                                          }, [...(_cache[41] || (_cache[41] = [
                                                            _createElementVNode("i", { class: "bi bi-filetype-jpg" }, null, -1)
                                                          ]))], 8, _hoisted_55),
                                                          _createElementVNode("button", {
                                                            class: "btn btn-custom",
                                                            onClick: ($event: any) => (_ctx.exportMpsGroupCsv(group)),
                                                            title: _ctx.$t('components.assetDetails.actions.exportCsv')
                                                          }, [...(_cache[42] || (_cache[42] = [
                                                            _createElementVNode("i", { class: "bi bi-filetype-csv" }, null, -1)
                                                          ]))], 8, _hoisted_56)
                                                        ])
                                                      ]),
                                                      _createElementVNode("div", _hoisted_57, [
                                                        (_openBlock(), _createBlock(_component_LineChart, {
                                                          key: 'mps-' + group.id + '-' + (_ctx.isDarkMode ? 'dark' : 'light'),
                                                          height: _ctx.wagoChartHeight,
                                                          "chart-id": 'mps-chart-' + group.id,
                                                          "chart-data": _ctx.dknChartData(group),
                                                          options: _ctx.dknChartOptions(group),
                                                          plugins: _ctx.chartPlugins
                                                        }, null, 8, ["height", "chart-id", "chart-data", "options", "plugins"]))
                                                      ])
                                                    ], 2))
                                                  : _createCommentVNode("", true)
                                              ], 64))
                                            }), 128)),
                                            (!_ctx.mpsHasAnyData)
                                              ? (_openBlock(), _createElementBlock("div", {
                                                  key: 0,
                                                  class: _normalizeClass(["chart-container chart-container-empty", { 'dark-mode': _ctx.isDarkMode }])
                                                }, [
                                                  _createElementVNode("div", _hoisted_58, [
                                                    _cache[43] || (_cache[43] = _createElementVNode("i", { class: "bi bi-graph-up" }, null, -1)),
                                                    _createElementVNode("div", _hoisted_59, _toDisplayString(_ctx.chartError || _ctx.$t('components.assetDetails.noHistory')), 1)
                                                  ])
                                                ], 2))
                                              : _createCommentVNode("", true)
                                          ], 64))
                                    ], 64))
                                  : (_ctx.isDknUartAsset)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                        (_ctx.chartLoading)
                                          ? (_openBlock(), _createElementBlock("div", {
                                              key: 0,
                                              class: _normalizeClass(["chart-container chart-container-empty", { 'dark-mode': _ctx.isDarkMode }])
                                            }, [
                                              _createElementVNode("div", _hoisted_60, [
                                                _createElementVNode("div", _hoisted_61, [
                                                  _createElementVNode("span", _hoisted_62, _toDisplayString(_ctx.$t('components.assetDetails.loading')), 1)
                                                ])
                                              ])
                                            ], 2))
                                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.uartChartGroups, (group) => {
                                                return (_openBlock(), _createElementBlock(_Fragment, {
                                                  key: group.id
                                                }, [
                                                  (_ctx.dknGroupHasData(group))
                                                    ? (_openBlock(), _createElementBlock("div", {
                                                        key: 0,
                                                        class: _normalizeClass(["chart-container mb-3", { 'dark-mode': _ctx.isDarkMode }])
                                                      }, [
                                                        _createElementVNode("div", _hoisted_63, [
                                                          _createElementVNode("h3", _hoisted_64, [
                                                            _cache[44] || (_cache[44] = _createElementVNode("i", { class: "bi bi-graph-up" }, null, -1)),
                                                            _createElementVNode("span", null, _toDisplayString(_ctx.$t(group.titleKey)), 1)
                                                          ]),
                                                          _createElementVNode("div", _hoisted_65, [
                                                            _createElementVNode("button", {
                                                              class: "btn btn-custom",
                                                              onClick: ($event: any) => (_ctx.resetZoom('uart-chart-' + group.id)),
                                                              title: _ctx.$t('components.assetDetails.actions.resetZoom')
                                                            }, [...(_cache[45] || (_cache[45] = [
                                                              _createElementVNode("i", { class: "bi bi-arrow-clockwise" }, null, -1)
                                                            ]))], 8, _hoisted_66),
                                                            _createElementVNode("button", {
                                                              class: "btn btn-custom",
                                                              onClick: ($event: any) => (_ctx.exportUartGroupToPng(group)),
                                                              title: _ctx.$t('components.assetDetails.actions.exportPng')
                                                            }, [...(_cache[46] || (_cache[46] = [
                                                              _createElementVNode("i", { class: "bi bi-filetype-png" }, null, -1)
                                                            ]))], 8, _hoisted_67),
                                                            _createElementVNode("button", {
                                                              class: "btn btn-custom",
                                                              onClick: ($event: any) => (_ctx.exportUartGroupToJpg(group)),
                                                              title: _ctx.$t('components.assetDetails.actions.exportJpg')
                                                            }, [...(_cache[47] || (_cache[47] = [
                                                              _createElementVNode("i", { class: "bi bi-filetype-jpg" }, null, -1)
                                                            ]))], 8, _hoisted_68),
                                                            _createElementVNode("button", {
                                                              class: "btn btn-custom",
                                                              onClick: ($event: any) => (_ctx.exportUartGroupCsv(group)),
                                                              title: _ctx.$t('components.assetDetails.actions.exportCsv')
                                                            }, [...(_cache[48] || (_cache[48] = [
                                                              _createElementVNode("i", { class: "bi bi-filetype-csv" }, null, -1)
                                                            ]))], 8, _hoisted_69)
                                                          ])
                                                        ]),
                                                        _createElementVNode("div", _hoisted_70, [
                                                          (_openBlock(), _createBlock(_component_LineChart, {
                                                            key: 'uart-' + group.id + '-' + (_ctx.isDarkMode ? 'dark' : 'light'),
                                                            height: _ctx.wagoChartHeight,
                                                            "chart-id": 'uart-chart-' + group.id,
                                                            "chart-data": _ctx.dknChartData(group),
                                                            options: _ctx.dknChartOptions(group),
                                                            plugins: _ctx.chartPlugins
                                                          }, null, 8, ["height", "chart-id", "chart-data", "options", "plugins"]))
                                                        ])
                                                      ], 2))
                                                    : _createCommentVNode("", true)
                                                ], 64))
                                              }), 128)),
                                              (!_ctx.uartHasAnyData)
                                                ? (_openBlock(), _createElementBlock("div", {
                                                    key: 0,
                                                    class: _normalizeClass(["chart-container chart-container-empty", { 'dark-mode': _ctx.isDarkMode }])
                                                  }, [
                                                    _createElementVNode("div", _hoisted_71, [
                                                      _cache[49] || (_cache[49] = _createElementVNode("i", { class: "bi bi-graph-up" }, null, -1)),
                                                      _createElementVNode("div", _hoisted_72, _toDisplayString(_ctx.chartError || _ctx.$t('components.assetDetails.noHistory')), 1)
                                                    ])
                                                  ], 2))
                                                : _createCommentVNode("", true)
                                            ], 64))
                                      ], 64))
                                    : (!_ctx.isChartFullscreen)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                          (_ctx.chartHasData)
                                            ? (_openBlock(), _createElementBlock("div", {
                                                key: 0,
                                                class: _normalizeClass(["chart-container", { 'dark-mode': _ctx.isDarkMode }])
                                              }, [
                                                _createElementVNode("div", _hoisted_73, [
                                                  _createElementVNode("h3", _hoisted_74, [
                                                    _cache[50] || (_cache[50] = _createElementVNode("i", { class: "bi bi-graph-up" }, null, -1)),
                                                    _createElementVNode("span", null, _toDisplayString(_ctx.getChartTitle()), 1)
                                                  ]),
                                                  _createElementVNode("div", _hoisted_75, [
                                                    _createElementVNode("button", {
                                                      class: "btn btn-custom",
                                                      disabled: !_ctx.chartHasData,
                                                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.openChartFullscreen && _ctx.openChartFullscreen(...args))),
                                                      title: _ctx.$t('components.assetDetails.actions.fullscreen')
                                                    }, [...(_cache[51] || (_cache[51] = [
                                                      _createElementVNode("i", { class: "bi bi-arrows-fullscreen" }, null, -1)
                                                    ]))], 8, _hoisted_76),
                                                    _createElementVNode("button", {
                                                      class: "btn btn-custom",
                                                      disabled: !_ctx.chartHasData,
                                                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.resetZoom('asset-chart'))),
                                                      title: _ctx.$t('components.assetDetails.actions.resetZoom')
                                                    }, [...(_cache[52] || (_cache[52] = [
                                                      _createElementVNode("i", { class: "bi bi-arrow-clockwise" }, null, -1)
                                                    ]))], 8, _hoisted_77),
                                                    _createElementVNode("button", {
                                                      class: "btn btn-custom chart-action-export",
                                                      disabled: !_ctx.chartHasData,
                                                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.exportToPng())),
                                                      title: _ctx.$t('components.assetDetails.actions.exportPng')
                                                    }, [...(_cache[53] || (_cache[53] = [
                                                      _createElementVNode("i", { class: "bi bi-filetype-png" }, null, -1)
                                                    ]))], 8, _hoisted_78),
                                                    _createElementVNode("button", {
                                                      class: "btn btn-custom chart-action-export",
                                                      disabled: !_ctx.chartHasData,
                                                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.exportToJpg())),
                                                      title: _ctx.$t('components.assetDetails.actions.exportJpg')
                                                    }, [...(_cache[54] || (_cache[54] = [
                                                      _createElementVNode("i", { class: "bi bi-filetype-jpg" }, null, -1)
                                                    ]))], 8, _hoisted_79),
                                                    _createElementVNode("button", {
                                                      class: "btn btn-custom chart-action-export",
                                                      disabled: !_ctx.chartHasData,
                                                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.exportCsv())),
                                                      title: _ctx.$t('components.assetDetails.actions.exportCsv')
                                                    }, [...(_cache[55] || (_cache[55] = [
                                                      _createElementVNode("i", { class: "bi bi-filetype-csv" }, null, -1)
                                                    ]))], 8, _hoisted_80)
                                                  ])
                                                ]),
                                                _createElementVNode("div", _hoisted_81, [
                                                  (_openBlock(), _createBlock(_component_LineChart, {
                                                    key: _ctx.chartRenderKey,
                                                    height: _ctx.chartHeight,
                                                    "chart-id": "asset-chart",
                                                    "chart-data": _ctx.chartData,
                                                    options: _ctx.chartOptions,
                                                    plugins: _ctx.chartPlugins
                                                  }, null, 8, ["height", "chart-data", "options", "plugins"]))
                                                ])
                                              ], 2))
                                            : (_openBlock(), _createElementBlock("div", {
                                                key: 1,
                                                class: _normalizeClass(["chart-container chart-container-empty", { 'dark-mode': _ctx.isDarkMode }])
                                              }, [
                                                (_ctx.chartLoading)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                                                      _createElementVNode("div", _hoisted_83, [
                                                        _createElementVNode("span", _hoisted_84, _toDisplayString(_ctx.$t('components.assetDetails.loading')), 1)
                                                      ])
                                                    ]))
                                                  : (_openBlock(), _createElementBlock("div", _hoisted_85, [
                                                      _cache[56] || (_cache[56] = _createElementVNode("i", { class: "bi bi-graph-up" }, null, -1)),
                                                      _createElementVNode("div", _hoisted_86, _toDisplayString(_ctx.chartError || _ctx.$t('components.assetDetails.noHistory')), 1)
                                                    ]))
                                              ], 2))
                                        ], 64))
                                      : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_87, [
                            _createElementVNode("div", _hoisted_88, [
                              _createElementVNode("div", _hoisted_89, [
                                _createElementVNode("div", _hoisted_90, [
                                  _cache[57] || (_cache[57] = _createElementVNode("i", { class: "bi bi-image" }, null, -1)),
                                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.assetDetails.image.title')), 1)
                                ]),
                                _createElementVNode("button", {
                                  class: "asset-tile-action",
                                  type: "button",
                                  title: _ctx.$t('components.assetDetails.image.open'),
                                  onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.openImageModal && _ctx.openImageModal(...args)))
                                }, [...(_cache[58] || (_cache[58] = [
                                  _createElementVNode("i", { class: "bi bi-arrows-fullscreen" }, null, -1)
                                ]))], 8, _hoisted_91)
                              ]),
                              _createElementVNode("div", {
                                class: "asset-tile-media",
                                onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.openImageModal && _ctx.openImageModal(...args)))
                              }, [
                                _createElementVNode("img", {
                                  src: _ctx.getAssetImageOrPlaceholder(),
                                  alt: _ctx.asset.name || _ctx.$t('components.assetDetails.image.alt'),
                                  class: "asset-tile-media-img"
                                }, null, 8, _hoisted_92),
                                _createElementVNode("div", _hoisted_93, [
                                  _cache[59] || (_cache[59] = _createElementVNode("i", { class: "bi bi-arrows-fullscreen" }, null, -1)),
                                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.assetDetails.image.clickToZoom')), 1)
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_94, [
                              _createElementVNode("div", _hoisted_95, [
                                _createElementVNode("div", _hoisted_96, [
                                  _cache[60] || (_cache[60] = _createElementVNode("i", { class: "bi bi-speedometer2" }, null, -1)),
                                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.assetDetails.currentParameters')), 1)
                                ])
                              ]),
                              (_ctx.isDevice)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
                                    _createElementVNode("div", _hoisted_98, [
                                      _createElementVNode("div", _hoisted_99, [
                                        _cache[61] || (_cache[61] = _createElementVNode("i", { class: "bi bi-arrows-move" }, null, -1)),
                                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.assets.dataGrids.xAxis')), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_100, _toDisplayString(_ctx.getAxisValue('X_AXIS')), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_101, [
                                      _createElementVNode("div", _hoisted_102, [
                                        _cache[62] || (_cache[62] = _createElementVNode("i", { class: "bi bi-arrows-vertical" }, null, -1)),
                                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.assets.dataGrids.yAxis')), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_103, _toDisplayString(_ctx.getAxisValue('Y_AXIS')), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_104, [
                                      _createElementVNode("div", _hoisted_105, [
                                        _cache[63] || (_cache[63] = _createElementVNode("i", { class: "bi bi-arrows-collapse" }, null, -1)),
                                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.assets.dataGrids.zAxis')), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_106, _toDisplayString(_ctx.getAxisValue('Z_AXIS')), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_107, [
                                      _createElementVNode("div", _hoisted_108, [
                                        _cache[64] || (_cache[64] = _createElementVNode("i", { class: "bi bi-activity" }, null, -1)),
                                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.assets.dataGrids.magnitude')), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_109, _toDisplayString(_ctx.getAxisMagnitude()), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_110, [
                                      _createElementVNode("div", _hoisted_111, [
                                        _cache[65] || (_cache[65] = _createElementVNode("i", { class: "bi bi-activity" }, null, -1)),
                                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.assets.dataGrids.magnitudeNoGravity')), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_112, _toDisplayString(_ctx.getAxisMagnitudeNoGravity()), 1)
                                    ])
                                  ]))
                                : (_ctx.isDknUartAsset)
                                  ? (_openBlock(), _createBlock(_component_DknUartLatestParamsPanel, {
                                      key: 1,
                                      "latest-params": _ctx.asset.latest_params || []
                                    }, null, 8, ["latest-params"]))
                                  : (_ctx.isDknMpsAsset)
                                    ? (_openBlock(), _createBlock(_component_DknMpsLatestParamsPanel, {
                                        key: 2,
                                        "latest-params": _ctx.asset.latest_params || []
                                      }, null, 8, ["latest-params"]))
                                    : (_ctx.isDknLmsAsset)
                                      ? (_openBlock(), _createBlock(_component_DknLmsLatestParamsPanel, {
                                          key: 3,
                                          "latest-params": _ctx.asset.latest_params || []
                                        }, null, 8, ["latest-params"]))
                                      : (_ctx.isWagoModbusAsset)
                                        ? (_openBlock(), _createBlock(_component_WagoLatestParamsPanel, {
                                            key: 4,
                                            "latest-params": _ctx.asset.latest_params || [],
                                            "is-dark-mode": _ctx.isDarkMode
                                          }, null, 8, ["latest-params", "is-dark-mode"]))
                                        : (_ctx.isModbusAsset)
                                          ? (_openBlock(), _createBlock(_component_ModbusLatestParamsPanel, {
                                              key: 5,
                                              "latest-params": _ctx.asset.latest_params || []
                                            }, null, 8, ["latest-params"]))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_113, [
                                              _createElementVNode("div", {
                                                class: "asset-stat",
                                                style: _normalizeStyle({ '--stat-accent': _ctx.getTemperatureColor() })
                                              }, [
                                                _createElementVNode("div", _hoisted_114, [
                                                  _cache[66] || (_cache[66] = _createElementVNode("i", { class: "bi bi-thermometer-half" }, null, -1)),
                                                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.assets.dataGrids.temperature')), 1)
                                                ]),
                                                _createElementVNode("div", _hoisted_115, _toDisplayString(_ctx.getTemperature()), 1)
                                              ], 4),
                                              _createElementVNode("div", {
                                                class: "asset-stat",
                                                style: _normalizeStyle({ '--stat-accent': _ctx.getHumidityColor() })
                                              }, [
                                                _createElementVNode("div", _hoisted_116, [
                                                  _cache[67] || (_cache[67] = _createElementVNode("i", { class: "bi bi-droplet-half" }, null, -1)),
                                                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.assets.dataGrids.humidity')), 1)
                                                ]),
                                                _createElementVNode("div", _hoisted_117, _toDisplayString(_ctx.getHumidity()), 1)
                                              ], 4),
                                              _createElementVNode("div", _hoisted_118, [
                                                _createElementVNode("div", _hoisted_119, [
                                                  _cache[68] || (_cache[68] = _createElementVNode("i", { class: "bi bi-lightning-charge-fill" }, null, -1)),
                                                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.assets.dataGrids.power')), 1)
                                                ]),
                                                _createElementVNode("div", _hoisted_120, _toDisplayString(_ctx.getPowerSupply()), 1)
                                              ]),
                                              _createElementVNode("div", {
                                                class: _normalizeClass(["asset-stat", _ctx.getBatteryStatusClass()])
                                              }, [
                                                _createElementVNode("div", _hoisted_121, [
                                                  _cache[69] || (_cache[69] = _createElementVNode("i", { class: "bi bi-battery-charging" }, null, -1)),
                                                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.assets.dataGrids.batteryStatus')), 1)
                                                ]),
                                                _createElementVNode("div", _hoisted_122, _toDisplayString(_ctx.getBatteryStatus()), 1)
                                              ], 2)
                                            ]))
                            ]),
                            _createElementVNode("div", _hoisted_123, [
                              _createElementVNode("div", _hoisted_124, [
                                _createElementVNode("div", _hoisted_125, [
                                  _cache[70] || (_cache[70] = _createElementVNode("i", { class: "bi bi-info-circle" }, null, -1)),
                                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.assetDetails.basicInfo')), 1)
                                ])
                              ]),
                              _createElementVNode("ul", _hoisted_126, [
                                _createElementVNode("li", _hoisted_127, [
                                  _createElementVNode("span", _hoisted_128, _toDisplayString(_ctx.$t('components.assets.dataGrids.serialNumber')), 1),
                                  _createElementVNode("span", _hoisted_129, _toDisplayString(_ctx.getSerialNumber()), 1)
                                ]),
                                (_ctx.asset.company)
                                  ? (_openBlock(), _createElementBlock("li", _hoisted_130, [
                                      _createElementVNode("span", _hoisted_131, _toDisplayString(_ctx.$t('components.assets.dataGrids.company')), 1),
                                      _createElementVNode("span", _hoisted_132, _toDisplayString(_ctx.asset.company.name), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("li", _hoisted_133, [
                                  _createElementVNode("span", _hoisted_134, _toDisplayString(_ctx.$t('components.assets.dataGrids.lastActivity')), 1),
                                  _createElementVNode("span", _hoisted_135, _toDisplayString(_ctx.getLastActivity()), 1)
                                ]),
                                (_ctx.asset.location_description)
                                  ? (_openBlock(), _createElementBlock("li", _hoisted_136, [
                                      _createElementVNode("span", _hoisted_137, _toDisplayString(_ctx.$t('components.assets.dataGrids.locationDescription')), 1),
                                      _createElementVNode("span", _hoisted_138, _toDisplayString(_ctx.asset.location_description), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.tabContent === _ctx.TAB_HISTORY)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_139, [
                        _createVNode(_component_AssetHistory, {
                          "asset-id": _ctx.asset.id
                        }, null, 8, ["asset-id"])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.tabContent === _ctx.TAB_ALARMS)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_140, [
                        _createVNode(_component_DknAlarmTable, {
                          alarms: _ctx.alarms,
                          loading: _ctx.alarmsLoading,
                          error: _ctx.alarmsError,
                          "total-alarms": _ctx.alarmsSummary?.total ?? 0,
                          "is-dark-mode": _ctx.isDarkMode
                        }, null, 8, ["alarms", "loading", "error", "total-alarms", "is-dark-mode"])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
    ], 16),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.isChartFullscreen)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["chart-fullscreen-overlay", { 'dark-mode': _ctx.isDarkMode }]),
            onClick: _cache[16] || (_cache[16] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeChartFullscreen && _ctx.closeChartFullscreen(...args)), ["self"]))
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["chart-container chart-container-fullscreen", { 'dark-mode': _ctx.isDarkMode }])
            }, [
              _createElementVNode("div", _hoisted_141, [
                _createElementVNode("h3", _hoisted_142, [
                  _cache[71] || (_cache[71] = _createElementVNode("i", { class: "bi bi-graph-up" }, null, -1)),
                  _createElementVNode("span", null, _toDisplayString(_ctx.getChartTitle()), 1)
                ]),
                _createElementVNode("div", _hoisted_143, [
                  _createElementVNode("button", {
                    class: "btn btn-custom",
                    type: "button",
                    onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.closeChartFullscreen && _ctx.closeChartFullscreen(...args))),
                    title: _ctx.$t('components.assetDetails.actions.close')
                  }, [...(_cache[72] || (_cache[72] = [
                    _createElementVNode("i", { class: "bi bi-x-lg" }, null, -1)
                  ]))], 8, _hoisted_144),
                  _createElementVNode("button", {
                    class: "btn btn-custom",
                    disabled: !_ctx.chartHasData,
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.resetZoom('asset-chart'))),
                    title: _ctx.$t('components.assetDetails.actions.resetZoom')
                  }, [...(_cache[73] || (_cache[73] = [
                    _createElementVNode("i", { class: "bi bi-arrow-clockwise" }, null, -1)
                  ]))], 8, _hoisted_145),
                  _createElementVNode("button", {
                    class: "btn btn-custom",
                    disabled: !_ctx.chartHasData,
                    onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.exportToPng())),
                    title: _ctx.$t('components.assetDetails.actions.exportPng')
                  }, [...(_cache[74] || (_cache[74] = [
                    _createElementVNode("i", { class: "bi bi-filetype-png" }, null, -1)
                  ]))], 8, _hoisted_146),
                  _createElementVNode("button", {
                    class: "btn btn-custom",
                    disabled: !_ctx.chartHasData,
                    onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.exportToJpg())),
                    title: _ctx.$t('components.assetDetails.actions.exportJpg')
                  }, [...(_cache[75] || (_cache[75] = [
                    _createElementVNode("i", { class: "bi bi-filetype-jpg" }, null, -1)
                  ]))], 8, _hoisted_147),
                  _createElementVNode("button", {
                    class: "btn btn-custom",
                    disabled: !_ctx.chartHasData,
                    onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.exportCsv())),
                    title: _ctx.$t('components.assetDetails.actions.exportCsv')
                  }, [...(_cache[76] || (_cache[76] = [
                    _createElementVNode("i", { class: "bi bi-filetype-csv" }, null, -1)
                  ]))], 8, _hoisted_148)
                ])
              ]),
              (_ctx.chartHasData)
                ? (_openBlock(), _createElementBlock("div", _hoisted_149, [
                    (_openBlock(), _createBlock(_component_LineChart, {
                      key: _ctx.chartRenderKey,
                      height: _ctx.fullscreenChartHeight,
                      "chart-id": "asset-chart",
                      "chart-data": _ctx.chartData,
                      options: _ctx.chartOptions,
                      plugins: _ctx.chartPlugins
                    }, null, 8, ["height", "chart-data", "options", "plugins"]))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_150, [
                    (_ctx.chartLoading)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_151, [
                          _createElementVNode("div", _hoisted_152, [
                            _createElementVNode("span", _hoisted_153, _toDisplayString(_ctx.$t('components.assetDetails.loading')), 1)
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_154, [
                          _cache[77] || (_cache[77] = _createElementVNode("i", { class: "bi bi-graph-up" }, null, -1)),
                          _createElementVNode("div", _hoisted_155, _toDisplayString(_ctx.chartError || _ctx.$t('components.assetDetails.noHistory')), 1)
                        ]))
                  ]))
            ], 2)
          ], 2))
        : _createCommentVNode("", true)
    ]))
  ], 64))
}